module.exports = __webpack_public_path__ + "static/media/G1-7-Agatha-Petrides-cod27.b78de200.png";